import React from 'react'
import Layout from '../components/layout'
import EventRegistrationForm from '../components/EventRegistrationForm'

const Event = () => {
    return (
        <Layout>
            <EventRegistrationForm/>
        </Layout>
    )
}

export default Event